var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08203 6.6665L5.83203 11.3332C6.16536 11.6665 6.66537 11.6665 6.9987 11.3332C7.33203 10.9998 7.33203 10.4998 6.9987 10.1665L2.91536 5.99984L6.9987 1.83317C7.33203 1.49984 7.33203 0.999837 6.9987 0.666504C6.83203 0.499837 6.66536 0.416504 6.41536 0.416504C6.16536 0.416504 5.9987 0.499837 5.83203 0.666504L1.08203 5.33317C0.748698 5.74984 0.748698 6.24984 1.08203 6.6665C1.08203 6.58317 1.08203 6.58317 1.08203 6.6665Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeftIcon);
export default __webpack_public_path__ + "static/media/angle-left-icon.895c34efc78f4cec2ce78abbc38b8e65.svg";
export { ForwardRef as ReactComponent };